export default {
  'calander.guide': 'Calendar guide',
  'calander.redtheme': 'Red color',
  'calander.graytheme': 'Gray color',
  'calander.greentheme': 'Green color',
  'calander.bluetheme': 'Blue color',
  'calander.guidetitle':
    'The Colors of the Occasions Under the Calendar are as Follows.',
  'calander.redthemeguide':
    'This Color Indicates Official Holidays According to the Selected Country.',
  'calander.graythemeguide':
    'This Color Indicates the Religious Occasions of the Selected Country.',
  'calander.greenthemeguide':
    'This Color Indicates the Native Occasions of the Selected Country.',
  'calander.bluethemeguide':
    'This Color Indicates the Traditional Local Occasion of the Selected Country.',
  'calander.selectCountry': 'Country name to display events',
  'calander.changeDate': 'Change Date',
  'calander.changeType': 'Change Type',
  'calander.shamsi': 'Shamsi',
  'calander.miladi': 'Miladi',
  'calander.hijri': 'Hijri',
  'otheroption.otheroptions': 'Other Options',
  'calendar.calculateDate': 'Date Calculations',
  'otheroption.departuredate': 'Departure Date',
  'otheroption.returndate': 'Return Date',
  'otheroption.dayscount': 'day count',
  'otheroption.calculate': 'Calculate',
  'otheroption.timeinterval': 'Time Interval (Age)',
  'otheroption.alertinsertresult.en': 'The entered date is invalid.',
  'otheroption.untiltodayfuture': 'Time remaining from today.',
  'otheroption.untiltodaypast': 'Time elapsed until today.',
  'otheroption.otheroptionsguide1':
    'By selecting a country at the top of the calendar, events specific to that country are set on the calendar.',
  'otheroption.otheroptionsguide2':
    'By hovering over a day, any event for that day will be displayed at the bottom of the calendar.',
  'otheroption.otheroptionsguide3':
    'By clicking two dates, the time interval between them will be displayed.',
  'otheroption.otheroptionsguide4':
    "All events of the calendar are provided in a list format in the calendar's event section.",
};
